import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=fdf8a0da&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf8a0da')) {
      api.createRecord('fdf8a0da', component.options)
    } else {
      api.reload('fdf8a0da', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=fdf8a0da&", function () {
      api.rerender('fdf8a0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JOVLPPj0yi3A/JS/comp/ErrorMessage.vue"
export default component.exports